import { render, staticRenderFns } from "./eslGoodSelect.vue?vue&type=template&id=bffcbca2&scoped=true&"
import script from "./eslGoodSelect.vue?vue&type=script&lang=js&"
export * from "./eslGoodSelect.vue?vue&type=script&lang=js&"
import style0 from "./eslGoodSelect.vue?vue&type=style&index=0&id=bffcbca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffcbca2",
  null
  
)

export default component.exports